import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { JanelasAtualizacaoInformacoesCadastroComponent } from "./cadastro/janelas-atualizacao-informacoes-cadastro";
import { JanelasAtualizacaoInformacoesPesquisaComponent } from "./pesquisa/janelas-atualizacao-informacoes-pesquisa";
import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';

const routes:Routes = [
    {
        path: 'janelas-atualizacao-info/pesquisa',
        component: JanelasAtualizacaoInformacoesPesquisaComponent,
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
            dominios: DominiosResolver
        }, 
    },
    {
        path:'janelas-atualizacao-info/:id',
        component: JanelasAtualizacaoInformacoesCadastroComponent,
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
            dominios: DominiosResolver
        }, 
    },
    {
        path:'janelas-atualizacao-info',
        component: JanelasAtualizacaoInformacoesCadastroComponent,
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
            dominios: DominiosResolver
        }, 
    },    
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class JanelasAtualizacaoInformacoesRoutingModule{}